import { useWindowDimensions_custom } from "./useWindowDimensions_custom";

type Sizes = {
  /** Is ~phone sized AND landscape. Do what you can to compress content vertically. */
  isLandscape: boolean;
  /** Is viewport width > 810px */
  screen: { width: number; height: number };
  /** Maximum content width */
  contentWidth: number;
  /** Minimum Left/Right margin/padding on content */
  gutter: 16 | 18 | 24 | 40;
  /** Buttons stick to bottom of viewport w/ this margin */
  footerGutter: 16 | 24 | 32 | 56 | 64;
};

export function useDynamicSizes(): Sizes {
  const screen = useWindowDimensions_custom();

  const isLandscape = screen.width > screen.height;
  const isLandscapeAndPhoneSized = isLandscape && screen.height < 500;

  const isLargeViewport = screen.width >= 900;

  const contentWidth = isLargeViewport ? 700 : 600;

  const gutter = isLandscapeAndPhoneSized || screen.width > 40 + 342 + 40 ? 40 : 18;

  return {
    isLandscape: isLandscapeAndPhoneSized,
    screen,
    contentWidth,
    gutter,
    footerGutter:
      isLandscapeAndPhoneSized ? 16
      : gutter === 18 ? 16
      : screen.width > 1200 ? 64
      : isLargeViewport ? 56
      : 32,
  };
}
